export const footer = {
  footerTitleGame: "最好的游戏",
  footerTitleGameCasino: "赌场",
  footerTitleGameLottery: "彩票",
  footerTitleGameGames: "游戏",
  footerTitleSports: "体育",
  footerTitleGameSlots: "老虎机",
  footerTitleGameMinigame: "迷你游戏",
  footerTitleLiga: "联赛",
  footerTitleLigaEsports: "电子竞技",
  footerTitleLigaLeague: "联赛",
  footerTitleLigaFootball: "欧洲联赛",
  footerTitleSupport: "支持",
  footerTitleHelp: "帮助中心",
  footerTitleTerms: "条款和条件",
  footerTitleSocial: "关注我们",
  footerTitleApp: "下载我们的App",
  footerTitlePromotions: "促销",
  footerTitleResponsibleGambling: "负责任地游戏。仅限18岁以上。",
  footerTitleSafeGame: "为了更安全的游戏",
};
